import { Card, Container, Row } from 'react-bootstrap';
import ContentLoader from 'react-content-loader';
import { BrowserView, MobileView } from 'react-device-detect';

export default function JobListLoader() {
  return (
    <>
      <BrowserView>
        <Row>
          <Container
            className="pt-2 ms-4"
            data-testid="job-list-loader"
            style={{ width: '99%', height: '80%', minHeight: 600 }}
          >
            {[1, 2, 3, 4, 5].map((item) => {
              return (
                <Card
                  key={item}
                  className="mb-4"
                  style={{ width: '98%', height: '100%', borderRadius: '10px' }}
                >
                  <ContentLoader
                    speed={2}
                    width="100%"
                    height={116}
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                  >
                    <rect
                      x="0.8%"
                      y="10"
                      rx="0"
                      ry="0"
                      width="30%"
                      height="18"
                    />
                    <rect
                      x="0.8%"
                      y="35"
                      rx="0"
                      ry="0"
                      width="50%"
                      height="16"
                    />
                    <rect
                      x="0.8%"
                      y="68"
                      rx="0"
                      ry="0"
                      width="70%"
                      height="16"
                    />
                    <rect
                      x="0.8%"
                      y="90"
                      rx="0"
                      ry="0"
                      width="98.5%"
                      height="16"
                    />
                  </ContentLoader>
                </Card>
              );
            })}
          </Container>
        </Row>
      </BrowserView>
      <MobileView>
        <Row>
          <Container
            className="pt-2 ms-3"
            style={{ width: '99%', height: '80%', minHeight: 600 }}
          >
            {[1, 2, 3, 4, 5].map((item) => {
              return (
                <Card
                  key={item}
                  className="mb-2"
                  style={{
                    width: '92%',
                    height: '100%',
                    borderRadius: '10px',
                    marginLeft: '2px',
                  }}
                >
                  <ContentLoader
                    speed={2}
                    width="100%"
                    height={120}
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                  >
                    <rect x="2%" y="10" rx="0" ry="0" width="95%" height="45" />
                    <rect x="2%" y="65" rx="0" ry="0" width="95%" height="45" />
                  </ContentLoader>
                </Card>
              );
            })}
          </Container>
        </Row>
      </MobileView>
    </>
  );
}
